:host{display:table;border-collapse:collapse;border-spacing:0;max-width:calc(100% + 5rem);margin:0 -2.5rem}
/*# sourceMappingURL=assignment-multiple-select.component-6EZCWH3S.css.map */
